import React from 'react';
import { Box } from '@material-ui/core';
import StarIcon from '@material-ui/icons/Star';
import classes from './RatingCell.module.scss';

const RatingCell = ({ rating }) => {
  return (
    <Box className={classes.rating}>
      <StarIcon />
      {rating}
    </Box>
  );
};

export default RatingCell;
